import { useQuery } from "react-query";
import { GUEST_USER } from "../constants";
import { shouldRelease } from "../helpers/helperMethods";
import {customerBusinessService, locationMenuService} from "../services";
interface requestParams {
  token: string;
  location_id?: number;
  customer_id?: number;
  userType?: string;
}
interface requestParamsPayload {
  location_id?: number;
}

const getRewardCatalog = async (params: requestParams) => {
  const { location_id, token, customer_id } = params;
  const payload: requestParamsPayload = {}
  if( location_id ) payload.location_id = location_id
  const response = await customerBusinessService.getRewardCatalog(customer_id, payload )
  return response.data.data;
};

export default function useGetRewardCatalog(params: requestParams) {
  const {customer_id, userType} = params;
  const values = useQuery(["rewardCatalog"], () => getRewardCatalog(params), {
    // retry: false,
    enabled: !!customer_id && userType !== GUEST_USER && shouldRelease("Features","redeem"),
  });
  {
    /**Handlign erros received from API*/
  }
  // console.log(values);
  
  // values.isError &&
    // Toast_Func({
    //   status: false,
    //   /*TODO: replace with error message received from API once the API response is consistent*/
    //   message: "Reward catalog could not be fetched",
    // });

  return values;
}
